/**
 * KLKX API Service Layer
 *
 * Architecture:
 *   Direct rockieFile → Image (CORS-friendly from klakna.sbs)
 *   API data → Mock fallback (proxy requires session token)
 *   normalize() → Component (stable data shapes)
 */

import { normalizeHomeData } from './normalize'

// ===== Image URL — direct link (klakna.sbs serves these with CORS) =====
const ROCKIE_BASE = 'https://www.klakna.sbs/exchange/rockieFile/getFile'

export function getImageUrl(fileId) {
  return `${ROCKIE_BASE}?fileId=${fileId}`
}

// ===== Core API Calls (with mock fallback) =====

export async function fetchHomeData() {
  let res
  try {
    res = await fetch('/exchange/Home/pageHome', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
  } catch {
    return getMockHomeData()
  }
  if (!res.ok) return getMockHomeData()
  try {
    const raw = await res.json()
    return normalizeHomeData(raw)
  } catch {
    return getMockHomeData()
  }
}

export async function fetchConfig() {
  let res
  try { res = await fetch('/exchange/hashMap/getIsDisplay', { method: 'POST' }) } catch { return {} }
  if (!res.ok) return {}
  try { return await res.json() } catch { return {} }
}

// ===== Mock Fallback (offline dev) =====

function getMockHomeData() {
  return {
    coins: [
      { id: 1, symbol: 'BTCUSDT', fromSymbol: 'BTC', toSymbol: 'USDT',
        price: '78027.94', change: '-0.27', volume: '6503.32 BTC', high: '78599.99', low: '77721.19',
        iconUrl: getImageUrl('9007393') },
      { id: 2, symbol: 'ETHUSDT', fromSymbol: 'ETH', toSymbol: 'USDT',
        price: '2183.57', change: '+0.16', volume: '15623.45 ETH', high: '2199.80', low: '2156.30',
        iconUrl: getImageUrl('9007393') },
      { id: 3, symbol: 'BNBUSDT', fromSymbol: 'BNB', toSymbol: 'USDT',
        price: '652.06', change: '-0.48', volume: '8921.16 BNB', high: '658.90', low: '646.20',
        iconUrl: getImageUrl('9007393') },
      { id: 4, symbol: 'NEOUSDT', fromSymbol: 'NEO', toSymbol: 'USDT',
        price: '2.90', change: '-0.79', volume: '234567.00 NEO', high: '2.95', low: '2.86',
        iconUrl: getImageUrl('9007393') },
      { id: 5, symbol: 'LTCUSDT', fromSymbol: 'LTC', toSymbol: 'USDT',
        price: '55.86', change: '-0.64', volume: '45200.33 LTC', high: '56.50', low: '55.02',
        iconUrl: getImageUrl('9007393') },
      { id: 6, symbol: 'XRPUSDT', fromSymbol: 'XRP', toSymbol: 'USDT',
        price: '1.41', change: '-0.13', volume: '1234567.89 XRP', high: '1.43', low: '1.39',
        iconUrl: getImageUrl('9007393') },
    ],
    banners: [
      { fileId: '9007402', url: getImageUrl('9007402') },
      { fileId: '9007414', url: getImageUrl('9007414') },
      { fileId: '9007393', url: getImageUrl('9007393') },  // +1 banner for density parity
    ],
    partners: [
      { fileId: '9004501', url: getImageUrl('9004501') },
      { fileId: '9004495', url: getImageUrl('9004495') },
      { fileId: '9004494', url: getImageUrl('9004494') },
      { fileId: '9004486', url: getImageUrl('9004486') },
      { fileId: '9004484', url: getImageUrl('9004484') },
      { fileId: '9004478', url: getImageUrl('9004478') },
      { fileId: '9004476', url: getImageUrl('9004476') },
      { fileId: '9004470', url: getImageUrl('9004470') },
      { fileId: '9007393', url: getImageUrl('9007393') },   // extra logos for density
      { fileId: '9007402', url: getImageUrl('9007402') },
    ],
    config: {},
  }
}

export default { fetchHomeData, fetchConfig, getImageUrl }
